import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SideBar from "../components/SideBar";
import "../styles/MemberDetails.css";
import { FaRegUserCircle } from "react-icons/fa";
import { MdOutlineLocationOn, MdUpdate, MdOutlineAssignmentInd } from "react-icons/md";

function AgentDetails() {
  const location = useLocation();
  const agent = location.state?.agent;
  const navigate = useNavigate();

  if (!agent) {
    return <p style={{ padding: "30px" }}>No more data available.</p>;
  }

  const goToWallet = () => {
    navigate("/agent-wallet-details", { state: { agent } });
  };

  const goToEdit = () => {
    navigate("/edit-agent-profile", { state: { agent } });
  };

  const goToInviteHistory = () => {
    navigate("/agent-invite-history", { state: { agent } });
  };

  const goToPromotion = () => {
    navigate("/agent-promotion", { state: { agent } });
  }

  

  return (
    <div className="member-details-layout">
      <SideBar />

      <div className="member-details-main">
        {/* Header */}
        <div className="details-header">
          <h2 style={{width:"330px"}}>Retail Business Agent Details</h2>
          <p>You can edit your details to update your profile</p>
        </div>

        {/* Breadcrumb */}
        <div className="breadcrumb">
          <Link to="/manage-agent" className="breadcrumb-link">
            Home
          </Link>
          <span className="breadcrumb-separator">{">"}</span>
          <Link to="/manage-agent" className="breadcrumb-link">
            Manage Retail Business Agent
          </Link>
          <span className="breadcrumb-separator">{">"}</span>
          <span className="breadcrumb-current">Agent Details</span>
        </div>

        {/* buttons */}
        <div className="top-bar">
          {/* tap buttons */}
          <div className="top-buttons">
            <button className="tab-btn active">Personal Details</button>
            <button className="tab-btn" onClick={goToWallet}>
              Wallet Details
            </button>
            <button className="tab-btn" onClick={goToInviteHistory}>
              Invitation Details
            </button>
            <button className="tab-btn" onClick={goToPromotion}>
              Promote / Demote
            </button>
          </div>
        </div>

        {/* edit button */}
        {/* <div className="edit-btn-wrap">
          <button className="edit-btn">Edit</button>
        </div> */}

        {/* Basic Details */}
        <div className="section">
          {/* edit button */}
          <div className="edit-btn-wrap">
            <button className="edit-btn" onClick={goToEdit}>
              Edit
            </button>
          </div>
          <h3>
            <FaRegUserCircle /> Basic Details
          </h3>
          <div className="section-content">
            <p>
              <strong>First name:</strong> {agent.firstName}
            </p>
            <p>
              <strong>Surname:</strong> {agent.surname}
            </p>
            <p>
              <strong>Email:</strong> {agent.email}
            </p>
            <p>
              <strong>Mobile:</strong> {agent.mobile}
            </p>
            <p>
              <strong>Role:</strong> {agent.role}
            </p>
          </div>
        </div>

        {/* Address */}
        <div className="section">
          <h3>
            <MdOutlineLocationOn /> Address
          </h3>
          <div className="section-content">
            <p>
              <strong>Address line 1:</strong> {agent.address.line1}
            </p>
            <p>
              <strong>Address line 2:</strong> {agent.address.line2}
            </p>
            <p>
              <strong>Address line 3:</strong> {agent.address.line3}
            </p>
            <p>
              <strong>City:</strong> {agent.address.city}
            </p>
            <p>
              <strong>Region:</strong> {agent.address.county}
            </p>
            <p>
              <strong>Postcode:</strong> {agent.address.postcode}
            </p>
            <p>
              <strong>Country:</strong> {agent.address.country}
            </p>
            
          </div>
        </div>

        {/* Status */}
        <div className="section">
          <h3>
            <MdUpdate /> Status
          </h3>
          <div className="section-content">
            <p>
              <strong>Email Status:</strong> {agent.status}
            </p>
            <p>
              <strong>Notes:</strong> {agent.notes}
            </p>
          </div>
        </div>

        {/* Referred By */}
                <div className="section">
                  <h3><MdOutlineAssignmentInd /> Referred By</h3>
                  <div className="section-content">
                    <p><strong>Referrer ID:</strong> {agent.referrer_id || 'N/A'}</p>
                    <p><strong>Referrer:</strong> {agent.referrer_name || 'N/A'}</p>

                  <p><strong>Referrer Agent Type:</strong> {agent.referrer_agent_type}</p>
                  <p><strong>Referrer Country:</strong> {agent.referrer_country || 'N/A'}</p>
                  <p><strong>Referrer Region:</strong> {agent.referrer_region || 'N/A'}</p>
                  <p><strong>Referrer Email:</strong> {agent.referrer_email || 'N/A'}</p>
                  <p><strong>Referrer Phone:</strong> {agent.referrer_phone || 'N/A'}</p>
                  </div>
              </div>
      </div>
    </div>
  );
}

export default AgentDetails;
